export class LanguageTranslationsFiltersRequest {
  translation_key?: string;
}
